import React from "react";
import { useAuth } from "react-oidc-context";
import "./Sidebar.css";
import SidebarItem from "./SidebarItem";
import LogoutIcon from "@mui/icons-material/Logout";
// @ts-ignore - ignore type resolution for png assets
import LuniwaveLogo from "../../../img/v2/logo_vert_sans_fond_300dpi_2.png";

const getInitials = (name) => {
  if (!name) {
    return "LM";
  }
  const cleaned = name.trim().split(" ");
  if (cleaned.length === 1) {
    return cleaned[0].slice(0, 2).toUpperCase();
  }
  return (cleaned[0][0] + cleaned[cleaned.length - 1][0]).toUpperCase();
};

const V2Sidebar = ({ items = [], sections, loading = false, activeKey, onSelect, userProfile }) => {
  const auth = useAuth();
  const initials = userProfile?.picture ? null : getInitials(userProfile?.name);

  // Même flux que LuniManager : signoutRedirect termine la session Keycloak
  // ET purge les tokens locaux, puis renvoie sur post_logout_redirect_uri.
  const handleLogout = () => {
    auth.signoutRedirect();
  };

  const navItems = items.length
    ? items
    : (sections || []).flatMap((section) => section.items || []);

  return (
    <aside className="v2-sidebar">
      <div className="v2-sidebar__content">
        <div className="v2-sidebar__logo">
          <img className="v2-sidebar__logo-img" src={LuniwaveLogo} alt="Luniwave" />
        </div>

        <nav className="v2-sidebar__nav" aria-label="Navigation V2">
          {loading ? (
            <ul className="v2-sidebar__nav-list v2-sidebar__nav-list--loading" aria-hidden="true">
              {[1, 2, 3].map((i) => (
                <li key={i} className="v2-sidebar__nav-skeleton" />
              ))}
            </ul>
          ) : (
            <ul className="v2-sidebar__nav-list">
              {navItems.map((item) => (
                <SidebarItem
                  key={item.key}
                  item={item}
                  isActive={activeKey === item.key}
                  onSelect={onSelect}
                />
              ))}
            </ul>
          )}
        </nav>
      </div>

      <div className="v2-sidebar__divider" />

      <footer className="v2-sidebar__profile">
        <div className="v2-sidebar__avatar">
          {userProfile?.picture ? (
            <img src={userProfile.picture} alt={userProfile.name} />
          ) : (
            <span>{initials}</span>
          )}
        </div>
        <div className="v2-sidebar__profile-text">
          <p className="v2-sidebar__profile-name">{userProfile?.name ?? "Luni Manager"}</p>
        </div>
        <button
          type="button"
          className="v2-sidebar__logout"
          onClick={handleLogout}
          aria-label="Se déconnecter"
          title="Se déconnecter"
        >
          <LogoutIcon aria-hidden="true" fontSize="small" />
        </button>
      </footer>
    </aside>
  );
};

export default V2Sidebar;
